export default __webpack_public_path__ + "static/media/topupInfo.e885111a.svg";